const TAG = '@/store/history:';
const getHistoryItemsFromLocalStorage = () => {
  let historyItemsLocalStorage = localStorage.getItem('history');
  let historyItems = historyItemsLocalStorage ? JSON.parse(historyItemsLocalStorage) : [];
  return historyItems;
};
const state = {
  historyItems: () => getHistoryItemsFromLocalStorage(),
};

const getters = {
  historyItems(state) {
    let historyItemsLocalStorage = localStorage.getItem('history');
    let historyItems = historyItemsLocalStorage ? JSON.parse(historyItemsLocalStorage) : [];
    state.historyItems = historyItems;
    return historyItems;
  },
};

const mutations = {
  addItem(state, { item }) {
    if (item) {
      console.log('history/addItem');
      let historyItems = getHistoryItemsFromLocalStorage();

      historyItems.push(item);
      if (historyItems.length > 10) {
        historyItems.shift();
      }
      localStorage.setItem('history', JSON.stringify(historyItems));
      state.historyItems = historyItems;
    }
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
